import React from 'react';
import DesktopOperations from './DesktopOperations';
import MobileOperations from './MobileOperations';

const Operations = () => {
  return (
    <div>
      <div
        className={`hidden lg:flex flex-col
`}
      >
        <DesktopOperations />
      </div>
      <div className={`flex lg:hidden`}>
        <MobileOperations />
      </div>
    </div>
  );
};

export default Operations;
